import useReveal from '@/hooks/useReveal';
import { CRAFT_IMG } from '@/lib/imageFallbacks';

const ABOUT_IMG = CRAFT_IMG;

export default function Craft() {
  const reveal = useReveal();
  return (
    <section
      id="craft"
      ref={reveal}
      className="mw-reveal relative py-24 sm:py-32 bg-[var(--mw-bg)]"
    >
      <div className="max-w-screen-2xl mx-auto px-6 sm:px-10 lg:px-16 grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <div className="lg:col-span-6 order-2 lg:order-1">
          <div className="flex items-center gap-3 mb-6">
            <span className="block w-10 h-px bg-white/40" />
            <span className="text-[10px] uppercase tracking-[0.32em] text-white/55">
              The Craft · 002
            </span>
          </div>
          <h2 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl text-white leading-[0.95] tracking-tight">
            A wholesale butcher,
            <br />
            <em className="not-italic text-[var(--mw-primary)]">obsessed</em> with the detail.
          </h2>

          <div className="mt-8 space-y-5 text-white/70 text-base sm:text-lg leading-relaxed max-w-xl">
            <p>
              From our cutting room in Malaga, our butchers break, trim and portion
              every order to spec. No machine fillers, no shortcuts — just clean
              cuts, accurate weights and full traceability from paddock to pass.
            </p>
            <p>
              We work directly with Western Australian farmers and certified
              suppliers, sourcing Halal-certified, organic and grass-fed
              product. Smallgoods, sausages and salami are cured in-house.
            </p>
          </div>

          <div className="mt-10 grid sm:grid-cols-3 gap-6">
            {[
              { k: 'Sourcing', v: 'Direct from WA farms' },
              { k: 'Cutting', v: 'Hand-trimmed to spec' },
              { k: 'Curing', v: 'In-house, slow-aged' },
            ].map((c) => (
              <div key={c.k} className="border-t border-white/15 pt-4">
                <div className="text-[10px] uppercase tracking-[0.28em] text-white/55">{c.k}</div>
                <div className="mt-2 font-display text-xl text-white">{c.v}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-6 order-1 lg:order-2">
          <div className="relative aspect-[4/5] overflow-hidden mw-grain">
            <img
              src={ABOUT_IMG}
              alt="Butcher carefully trimming meat under dim light"
              className="absolute inset-0 w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-tr from-black/60 via-transparent to-transparent" />
            <div className="absolute top-6 left-6 text-[10px] uppercase tracking-[0.32em] text-white/70">
              15 Action Rd · Malaga WA 6090
            </div>
            <div className="absolute bottom-6 left-6 text-[10px] uppercase tracking-[0.32em] text-white/70">
              <a href="tel:+61435111667" className="hover:text-white transition-colors">0435 111 667</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
